import { FormControl, MenuItem, Select } from "@material-ui/core"
import PropTypes from "prop-types"
import useStyles from "./styles"

const CourseClientFilter = ({ client, handleChangeClient, options }) => {
  const classes = useStyles()

  return (
    <FormControl variant="outlined" className={classes.selectContainer}>
      <Select
        value={client}
        onChange={handleChangeClient}
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
      >
        <MenuItem value={0}>All Clients</MenuItem>
        {options &&
          options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  )
}

CourseClientFilter.propTypes = {
  client: PropTypes.number,
  handleChangeClient: PropTypes.func,
  options: PropTypes.array,
}
export default CourseClientFilter
